import { Injectable } from '@angular/core'
import { reactor } from '../reactor'
import { geoOperations } from '../stores/geo-store'
import { CountriesService } from '../services/countries-service'
import { TimeZonesService } from '../services/time-zones-service'
import { donePromise } from '../utils'
import { errorToast } from '../toaster'

@Injectable({providedIn: 'root'})
export class GeoActions {
  private countriesService: CountriesService = new CountriesService();
  private timeZonesService: TimeZonesService = new TimeZonesService();

  loadCountries() {
    const p = this.countriesService.getCountries().then((countries) => {
      reactor.dispatch(geoOperations.setCountries, countries)
    })
    .catch(() => {
      errorToast("Countries failed to load")
    })
    return donePromise(p)
  }

  loadStatesForCountry(countryId: string) {
    const p = this.countriesService.getStatesForCountry(countryId).then((states) => {
      reactor.dispatch(geoOperations.setStates, {countryId, states})
    })
    .catch(() => {
      errorToast("States failed to load")
    })
    return donePromise(p)
  }

  loadTimeZones() {
    this.timeZonesService.getTimeZones().then((zones) => {
      reactor.dispatch(geoOperations.setTimeZones, zones)
    })
  }

}

